module.exports = __webpack_public_path__ + "img/calendar-event.0d500b8b.svg";